import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, message, Modal } from 'antd';
import gql from 'graphql-tag';
import { useState } from 'react';
import { useAuthedMutationWithNotification } from 'utils/qlAuth';

export const UniverseController_genStories = (props: { qUniverse: any; id: number }) => {
  const [inLoading, setInLoading] = useState(false);

  const [genStories, answerGenStories] = useAuthedMutationWithNotification(gql`
    mutation UniverseController_genStories($id: Int!) {
      UniverseController_genStories(id: $id) {
        id
      }
    }
  `);

  return (
    <Button
      disabled={inLoading}
      size="small"
      onClick={async () => {
        Modal.confirm({
          title: `Do you want build stories?`,
          icon: <ExclamationCircleOutlined />,
          content: `Do you want build stories?`,
          onOk: async () => {
            try {
              setInLoading(true);
              message.info('Create stories start');
              await genStories({ variables: { id: Number(props.id) } });
              message.success('Create stories Done');
              setInLoading(false);
              props.qUniverse.refetch();
            } catch (e) {
              console.log(e);
              setInLoading(false);
            }
          },
        });
      }}
    >
      Create stories
    </Button>
  );
};

export const UniverseController_removeAllStories = (props: { qUniverse: any; id: number }) => {
  const [inLoading, setInLoading] = useState(false);

  const [doMutation, answerBuildTts] = useAuthedMutationWithNotification(gql`
    mutation UniverseController_removeAllStories($id: Int!) {
      UniverseController_removeAllStories(id: $id)
    }
  `);

  return (
    <Button
      disabled={inLoading}
      type="dashed"
      size="small"
      danger
      onClick={async () => {
        Modal.confirm({
          title: `Do you want clean all stories?`,
          icon: <ExclamationCircleOutlined />,
          content: `Do you want clean all stories?`,
          onOk: async () => {
            try {
              setInLoading(true);
              await doMutation({ variables: { id: Number(props.id) } });
              message.success('Done');
              setInLoading(false);
              props.qUniverse.refetch();
            } catch (e) {
              console.log(e);
              setInLoading(false);
            }
          },
        });
      }}
    >
      Remove all stories
    </Button>
  );
};
